import { z } from 'my-zod'
import { addOnProductModel } from './add-on-product-model'

export const addOnProductUpsertFragment = addOnProductModel.augment({
  shortId: addOnProductModel.shape.shortId.optional()
})

export type addOnProductUpsertFragment = z.infer<typeof addOnProductUpsertFragment>
